import {
  Box,
  makeStyles,
  InputAdornment,
  IconButton,
  TextField,
  FormControl,
} from "@material-ui/core";
import { CgSearch } from "react-icons/cg";
import React from "react";

const useStyles = makeStyles((theme) => ({
  filterTabBox: {
    position: "relative",
    padding: "2px 0 17px",
    zIndex: "9",
  },
  searcBox: {
    width: "40%",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: " 10px !important",
      height: "50px",
    },
    "& .MuiInputAdornment-positionStart": {
      marginRight: "0px",
      paddingLeft: "0px",
    },
    "& .MuiIconButton-root": {
      background: theme.palette.background.blur,
      padding: "8px",
      marginLeft: "0px",
      width: "33px !important",
      height: "33px",
      minWidth: "auto",
      borderRadius: "50px",
      "& svg": {
        marginLeft: "-3px",
      },
    },
  },
}));
export default function FilterBox({
  setSearch,
  search,
  newClasses,
  searchName,
}) {
  const classes = useStyles();
  const checkClass = newClasses ? newClasses : classes;

  return (
    <Box className={checkClass.filterTabBox}>
      <Box className="displaySpacebetween filterwrap">
        <FormControl className={checkClass.searcBox}>
          <TextField
            type="search"
            fullWidth
            variant="outlined"
            id="outlined-adornment-weight"
            className="field"
            placeholder={searchName ? searchName : "Search here..."}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton>
                    <CgSearch />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            aria-describedby="outlined-weight-helper-text"
          />
        </FormControl>
      </Box>
    </Box>
  );
}
